import { DURATION } from '../constants/couponConstants';

export function getPromoString(
    coupon,
    discountedPrice,
    regularPrice,
    term,
    shortenedTerm,
    currency,
    isAnnualPlan,
    isFTC,
    hasTrial,
) {
    const offerPriceString = getOfferPriceString(
        currency,
        discountedPrice,
        term,
        shortenedTerm,
        coupon,
        isFTC,
    );
    const durationString = getDurationString(coupon, term, isAnnualPlan, isFTC);
    const afterPromoString = getAfterPromoString(
        coupon,
        currency,
        regularPrice,
        shortenedTerm,
        isFTC,
        hasTrial,
    );

    return `${offerPriceString}${durationString}${afterPromoString}`;
}

export function getOfferPriceString(currency, discountedPrice, term, shortenedTerm, coupon, isFTC) {
    const offerPriceString = `${currency}${discountedPrice}`;
    term = term.toLowerCase();

    switch (coupon?.duration) {
        case DURATION.TEMPORAL:
            const termDisplay =
                coupon.temporal_amount > 1
                    ? `/${isFTC ? shortenedTerm : term}`
                    : `${isFTC ? '' : `/${term}`}`;
            return `${offerPriceString}${termDisplay}`;
        case DURATION.SINGLE_USE:
            return offerPriceString;
        case DURATION.FOREVER:
        default:
            return `${offerPriceString}/${term}`;
    }
}

export function getDurationString(coupon, term, isAnnualPlan, isFTC) {
    const durationString = isFTC ? ' for the first' : ' for';
    term = term.toLowerCase();

    switch (coupon?.duration) {
        case DURATION.SINGLE_USE:
            return `${durationString}${isFTC ? '' : ' 1'} ${term}`;
        case DURATION.TEMPORAL:
            if (coupon.temporal_amount === 1) {
                return `${durationString} ${isFTC ? '' : '1 '}${term}`;
            } else {
                const temporalAmount = getTemporalAmount(coupon, isAnnualPlan);
                const temporalUnit = coupon?.temporal_unit;
                if (temporalUnit === 'day') {
                    term = temporalUnit;
                }

                return `${durationString} ${temporalAmount} ${term}s`;
            }
        // forever coupons have no duration string
        case DURATION.FOREVER:
        default:
            return ``;
    }
}

export function getAfterPromoString(
    coupon,
    currency,
    regularPrice,
    shortenedTerm,
    isFTC,
    hasTrial,
) {
    if (!isFTC) {
        return (coupon?.duration === DURATION.FOREVER && hasTrial) || (!coupon && hasTrial)
            ? ' after trial'
            : '';
    }

    switch (coupon?.duration) {
        case DURATION.FOREVER:
            // forever coupons have no after promo string
            return hasTrial ? ' after trial' : '';
        case DURATION.SINGLE_USE:
        case DURATION.TEMPORAL:
        default:
            return ` then ${currency}${regularPrice}/${shortenedTerm}`;
    }
}

function getTemporalAmount(coupon, isAnnualPlan) {
    if (coupon.temporal_unit === 'month' && isAnnualPlan) {
        return Math.ceil(coupon.temporal_amount / 12); // Round up to the nearest whole year
    }

    return coupon.temporal_amount;
}
